import MobileNetwork from './MobileNetworkViewModel'

export default class UserAccessClientViewModel {
    constructor(data) {
        this.carrier = new MobileNetwork(data.carrier);
        this.client = data.client;
    }
}
